import React from "react";
import { useSnapshot } from "valtio";

import { designStore, generalConfigStore } from "@store";

import { getBackgroundPathById } from "@helpers/general";

type PropsType = {
    children: React.ReactNode;
    selectedSubStep?: ProjectMainContentItemType;
    subStep?: any;
};

export function PreviewBackgroundWrapper({ children }: PropsType): JSX.Element {
    const {
        imageKey,
        files,
        project: { template },
    } = useSnapshot(generalConfigStore);
    const { activePageName } = useSnapshot(designStore);

    const BackgroundPge = (template.pages.subSteps[
        "accountFidelite"
    ] as PageType).background as BackgroundType;

    const [
        isBackgroundPreviewActive,
        setIsBackgroundPreviewActive,
    ] = React.useState(BackgroundPge.active);

    const [backgroundSrc, setBackgroundSrc] = React.useState(
        getBackgroundPathById(BackgroundPge.id as string, files) as {
            url: string;
            type: string;
        }
    );

    React.useEffect(() => {
        setBackgroundSrc(
            getBackgroundPathById(
                (BackgroundPge.id as string) ?? "",
                files
            ) as {
                url: string;
                type: string;
            }
        );
        setIsBackgroundPreviewActive(BackgroundPge.active);
    }, [activePageName, files, BackgroundPge]);

    return (
        <React.Fragment>
            {isBackgroundPreviewActive === true ? (
                backgroundSrc.type === "video" ? (
                    <React.Fragment>
                        <video
                            key={imageKey}
                            autoPlay={true}
                            muted={true}
                            loop={true}
                            style={{
                                height: "725px",
                                width: "430px",
                                objectFit: "cover",
                                position: "fixed",
                            }}
                            src={backgroundSrc.url}
                        />
                        {children}
                    </React.Fragment>
                ) : (
                    <div
                        key={imageKey}
                        style={{
                            backgroundImage: `url(${backgroundSrc.url})`,
                            height: "725px",
                            backgroundSize: "cover",
                        }}
                    >
                        {children}
                    </div>
                )
            ) : (
                <div
                    style={{
                        height: "725px",
                    }}
                >
                    {children}
                </div>
            )}
        </React.Fragment>
    );
}
